import { isObject } from "lodash";

export type BaseEvent = {
    event: string;
};

abstract class TagManagerBase<TEvent extends BaseEvent> {
    private readonly _dataLayer: string;

    private static isInitialised: { [key: string]: boolean } = {};

    public constructor(dataLayer = "dataLayer") {
        this._dataLayer = dataLayer;
    }

    /**
     * @description Initialise a GTM container. This handles \<noscript> as well
     * @param containerId E.g. GTM-XXXX
     */
    public initialise(containerId: string) {
        if (TagManagerBase.isInitialised[containerId]) {
            console.warn(
                `Attempting to initialise GTM with containerId '${containerId}' when it is already initialised. Skipping new initialisation.`
            );
            return;
        }

        const script = document.createElement("script");
        script.type = "text/javascript";

        const code = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','${this._dataLayer}','${containerId}');
    `;

        script.appendChild(document.createTextNode(code));
        document.body.appendChild(script);

        const iframe = document.createElement("iframe");
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
        iframe.width = "0";
        iframe.height = "0";
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";

        const noscript = document.createElement("noscript");
        noscript.appendChild(iframe);

        document.body.appendChild(noscript);

        TagManagerBase.isInitialised[containerId] = true;
    }

    public addEvent(event: TEvent) {
        if (window["dataLayer"] == null) {return;}

        const data = {};

        for (const key of Object.keys(event)) {
            data[`${key}`] = "" + event[key] + "";
        }

        dataLayer.push(event);
    }
}

export default TagManagerBase;
